mutation UpdateCharityBankAccountStatus(
  $input: UpdateCharityBankAccountStatusInput!
) {
  updateCharityBankAccountStatus(input: $input) {
    bankAccount {
      id
      status
      verificationNotes
      rejectionReason
      verifiedAt
    }
  }
}
